import * as tslib_1 from "tslib";
import moment from 'moment-timezone';
import React, { Component } from 'react'; // nextiva

import { Button } from '@nextiva/next-ui'; // own

import "./CustomOptions.css";
import DateRow from './DateRow/DateRow';

var CustomOptions =
/** @class */
function (_super) {
  tslib_1.__extends(CustomOptions, _super);

  function CustomOptions(props) {
    var _this = _super.call(this, props) || this;

    _this.prepareChanges = function (changes, field, newDate) {
      var hideEnd = _this.props.hideEnd;
      var _a = _this.state,
          start = _a.start,
          end = _a.end;

      if (!hideEnd && field === 'start' && newDate.isAfter(end)) {
        changes.start = end;
        changes.end = newDate;
      } else if (field === 'end' && newDate.isBefore(start)) {
        changes.start = newDate;
        changes.end = start;
      } else {
        changes[field] = newDate;
      }
    };

    _this.handleDateChange = function (field, newDate, hasError) {
      var _a;

      var changes = {
        errors: (_a = {}, _a[field] = hasError, _a)
      };

      if (!hasError) {
        _this.prepareChanges(changes, field, newDate);
      }

      _this.setState(changes);
    };

    _this.handleStartDateChange = function (newDate, hasError) {
      return _this.handleDateChange('start', newDate, hasError);
    };

    _this.handleEndDateChange = function (newDate, hasError) {
      return _this.handleDateChange('end', newDate, hasError);
    };

    _this.handleSave = function () {
      var _a = _this.props,
          hideEnd = _a.hideEnd,
          onSaveCancel = _a.onSaveCancel,
          onSave = _a.onSave;
      var _b = _this.state,
          start = _b.start,
          end = _b.end,
          errors = _b.errors; // check for errors in child components

      if (!start || !end || errors.start || errors.end) {
        return;
      } // check if start time is after end time


      if (hideEnd) {
        if (start.isAfter(moment())) {
          return onSaveCancel({
            message: 'Start time must be before now.'
          });
        }
      } else {
        if (start.isAfter(end)) {
          return onSaveCancel({
            message: 'Start time must be before end time.'
          });
        }
      }

      var dateRange = {
        type: 'absolute',
        start: start.toISOString(),
        end: end.toISOString()
      };
      onSave(dateRange);
    };

    _this.state = {
      start: moment.utc(props.start).tz(props.timezone),
      end: moment.utc(props.end).tz(props.timezone),
      errors: {}
    };
    return _this;
  }

  CustomOptions.prototype.render = function () {
    var _a = this.props,
        timezone = _a.timezone,
        hideEnd = _a.hideEnd;
    var _b = this.state,
        start = _b.start,
        end = _b.end;
    return React.createElement("div", {
      className: "drp-custom-options"
    }, React.createElement(DateRow, {
      className: "drp-custom-options__start",
      label: "Starts",
      date: start,
      timezone: timezone,
      onChange: this.handleStartDateChange,
      datePicker: {
        selectsStart: true,
        startDate: start,
        endDate: end
      }
    }), !hideEnd && React.createElement(DateRow, {
      className: "drp-custom-options__end",
      label: "Ends",
      date: end,
      timezone: timezone,
      onChange: this.handleEndDateChange,
      datePicker: {
        selectsEnd: true,
        startDate: start,
        endDate: end
      }
    }), React.createElement("div", {
      className: "drp-custom-options__footer"
    }, React.createElement(Button, {
      kind: "success",
      className: "drp-popover__btn-update",
      onClick: this.handleSave
    }, "Update")));
  };

  CustomOptions.defaultProps = {
    onSave: function onSave() {},
    onSaveCancel: function onSaveCancel() {}
  };
  return CustomOptions;
}(Component);

export default CustomOptions;